import { 
    nowInKyiv, 
    isAfter, 
    isBefore, 
    formatDate 
} from "@/src/shared/utils/dateTime";
import { TimeSettings } from "./type";
import { dayJsToDaysOfWeekMap } from "./constants";

export const isNotificationHidden = (settings?: TimeSettings): boolean => {
    if (!settings) return true;

    const currentDate = nowInKyiv();
    const currentDateString = formatDate(currentDate, "yyyy-MM-dd");

    if (settings.dateStart) {
        if (!isAfter(currentDate, settings.dateStart)) {
            return false;
        }
    }
    if (settings.dateEnd) {
        if (!isBefore(currentDate, settings.dateEnd)) {
            return false;
        }
    }
    if (settings.timeStart) {
        if (
            !isAfter(currentDate, `${currentDateString}T${settings.timeStart}`)
        ) {
            return false;
        }
    }
    if (settings.timeEnd) {
        if (!isBefore(currentDate, `${currentDateString}T${settings.timeEnd}`)) {
            return false;
        }
    }

    if (settings.daysSettings) {
        // Convert weekday from luxon (1-7, Monday is 1) to match map (0-6, Sunday is 0)
        const currentDay = dayJsToDaysOfWeekMap[(currentDate.weekday % 7)];
        const currentDaySettings = settings.daysSettings[currentDay];
        const isSettingsByDayEnabled = Object.values(
            settings.daysSettings,
        ).some((day) => !!day);

        if (!isSettingsByDayEnabled) {
            return true;
        }

        if (!currentDaySettings || !currentDaySettings?.enabled) {
            return false;
        }

        if (currentDaySettings.start) {
            if (
                !isAfter(
                    currentDate,
                    `${currentDateString}T${currentDaySettings.start}`,
                )
            ) {
                return false;
            }
        }
        if (currentDaySettings.end) {
            if (
                !isBefore(
                    currentDate,
                    `${currentDateString}T${currentDaySettings.end}`,
                )
            ) {
                return false;
            }
        }
    }

    return true;
};
